(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.agent:mxSchemaLink
	 * @module mx.agent
	 * @description Displays related object
	 * @param {string} label@ - Optional. Label of the control.
	 * @param {value} type= - Indicates what schema type used (class or type)
	 */

	angular.module('mx.SolutionBuilderAgent').component('mxSchemaLink', {
		require: {
			mxFormCtrl: '?^mxForm',
			parentViewController: '?^^mxView',
		},
		bindings: {
			value: '<',
			valueLabel: '@',
			label: '@',
			icon: '@',
			hideOnEmptyValue: '@',
			reserveIconSpace: '@',
			labelPosition: '@',
			valueMinWidth: '@',
			labelMinWidth: '@',
			labelMaxWidth: '@',
			valueColor: '@',
			designerMode: '<?',
			type: '@',
		},
		controller: MxSchemaLiteralCtrl,
		controllerAs: 'vm',
		template: [
			'$attrs',
			function (tAttrs) {
				var optmzr = typeof tAttrs.designerMode !== 'undefined' && ('' + tAttrs.designerMode).toLowerCase() !== 'false' ? '' : '::';
				return (
					'' +
					'<mx-literal ' +
					'label="{{::vm.label}}" ' +
					'type="link" ' +
					'value="' +
					optmzr +
					'vm.literalValue" ' +
					'icon="{{::vm.icon}}" ' +
					'hide-on-empty-value="{{::vm.hideOnEmptyValue}}"' +
					'reserve-icon-space="{{::vm.reserveIconSpace}}"' +
					'label-position="{{::vm.labelPosition}}" ' +
					'value-min-width="{{::vm.valueMinWidth}}" ' +
					'label-min-width="{{::vm.labelMinWidth}}" ' +
					'label-max-width="{{::vm.labelMaxWidth}}" ' +
					'value-color="{{::vm.valueColor}}"' +
					(typeof tAttrs.designerMode !== 'undefined' ? 'designer-mode="' + tAttrs.designerMode + '" ' : '') +
					'></mx-literal>'
				);
			},
		],
	});

	MxSchemaLiteralCtrl.$inject = ['mx.SolutionBuilderAgent.DialogOpenerService', 'mx.SolutionBuilderAgent.SchemaService', '$element', '$q'];

	function MxSchemaLiteralCtrl(dialogOpener, schemaService, $element, $q) {
		var vm = this;
		var displayStrings, _value;

		vm.$onInit = function () {
			_value = vm.value;

			Object.defineProperty(vm, 'displayStrings', {
				get: function () {
					return displayStrings;
				},
				set: setDisplayStrings,
			});

			Object.defineProperty(vm, 'value', {
				get: function () {
					return _value;
				},
				set: setValue,
			});

			setValue(_value);
		};

		vm.$postLink = function () {
			$element.addClass('mx-literal');
			vm.displayStrings = (vm.mxFormCtrl && vm.mxFormCtrl.displayStrings) || null;
		};

		function onClick() {
			var promise = vm.objDetails ? $q.when() : getObjectInfo(true);
			promise.then(function () {
				var obj = {
					_id: vm.objDetails.InternalName,
					_name: vm.objDetails.DisplayName,
					_type: vm.type === 'class' ? 'service_6886d8dc-51f8-e611-9382-f079595b3ec7' : 'service_7b83787c-81f7-e611-9382-f079595b3ec7',
				};
				dialogOpener.openPreview(obj, undefined, undefined, vm.parentViewController && vm.parentViewController.mxView);
			});
		}

		function setValue(value) {
			_value = value;
			vm.objDetails = null;
			vm.hasViews = undefined;
			if (_value) {
				if (typeof _value === 'object' && !_value.Id && !_value.Value) {
					_value = null;
					return;
				}

				vm.literalValue = {};
				if (vm.type) {
					vm.literalValue.onClick = onClick;
				}
				if (vm.valueLabel) {
					vm.literalValue.text = vm.valueLabel;
				}
			} else if (value === null) {
				vm.literalValue = null;
			} else {
				vm.literalValue = undefined;
			}

			setDisplayStrings(displayStrings);
		}

		function getObjectInfo(skipLiteralValue) {
			var promise = vm.type === 'class' ? schemaService.getClassInfoById(_value) : schemaService.getTypes();
			return promise.then(function (values) {
				if (!values) {
					return;
				}

				vm.objDetails =
					vm.type === 'class'
						? values
						: values.filter(function (item) {
								return item.Id.toLowerCase() === _value.toLowerCase();
						  })[0];

				if (skipLiteralValue) {
					return;
				}

				if (vm.literalValue) {
					vm.literalValue.onClick = onClick;
				} else {
					vm.literalValue = {};
				}

				vm.literalValue.text = vm.objDetails.DisplayName;
			});
		}

		function setDisplayStrings(value) {
			displayStrings = value;
			if (vm.literalValue && !vm.literalValue.text) {
				var displayString = _value._displayName ? _value._displayName : _value.DisplayString ? _value.DisplayString : _value.DisplayValue;

				if (!displayString) {
					if (displayStrings === null) {
						getObjectInfo();
					} else if (displayStrings) {
						var result = displayStrings.filter(function (item) {
							return item.Id === vm.value;
						});

						if (result.length === 1) {
							displayString = result[0].DisplayString;
						} else if (!result.length) {
							getObjectInfo();
						}
					}
				}

				if (displayString) {
					vm.literalValue.text = displayString;
				}
			}
		}
	}
})();
